import React, {Fragment, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {addExpenseTemplate, clearErrors} from "../../actions/expense_template";

const ExpenseTemplateCreateForm = ({
                                       addExpenseTemplate,
                                       clearErrors,
                                       error,
                                       loading,
                                       expense_templates,
                                       handleClose,
                                       show
                                   }) => {

    const formRef = useRef();

    const defaultValues = {
        name: '',
        color: '',
        category: '',
        type: '',
        is_for_sparepart: false
    };

    const [inputs, setInputs] = useState(defaultValues);
    const [errors, setErrors] = useState({});

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = {
            name: inputs.name,
            category: inputs.category,
            type: inputs.type,
            color: inputs.color,
            is_for_sparepart: inputs.is_for_sparepart || false,
        };
        addExpenseTemplate(data);
    };

    const handleChange = e => {
        setErrors({});
        e.target.oldValue = e.target.value;
        setInputs(prevState => ({...prevState, [e.target.name]: e.target.value}));
    };

    useEffect(() => {
        if (error && loading === false) {
            const errorsItems = error?.errors;
            let errorObject = {};
            if (error && error?.errors) {
                Object.keys(error?.errors).forEach((item) => errorObject[item] = errorsItems[item][0]);
            }
            setErrors(errorObject);

        }
    }, [error]);

    useEffect(() => {
        clearErrors();
        setErrors({});
        setInputs(defaultValues);
    }, [expense_templates]);

    const onClose = () => {
        clearErrors();
        setInputs(defaultValues);
        setErrors({});
        handleClose();
    };

    return (
        <Fragment>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Yangi harajat shabloni qo'shish</Modal.Title>
                </Modal.Header>

                <Modal.Body className="pt-3 pb-4 mx-3">

                    <form onSubmit={handleSubmit} ref={formRef}>

                        <div className="mb-3">
                            <label htmlFor="name">Nomi</label>
                            <input
                                name="name"
                                className={'form-control'}
                                type="text"
                                value={inputs?.name || ''}
                                placeholder={'kiriting'}
                                onChange={handleChange}
                                onKeyUp={e => e.target.oldValue = e.target.value}
                            />

                            <div className="error">
                                {errors?.name}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="category">Qisqartmasi</label>
                            <input
                                name="category"
                                className={'form-control'}
                                type="text"
                                value={inputs?.category || ''}
                                placeholder={'kiriting'}
                                onChange={handleChange}
                                onKeyUp={e => e.target.oldValue = e.target.value}
                            />

                            <div className="error">
                                {errors?.category}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="color">Grafikdagi rangi</label>
                            <input
                                name="color"
                                className={'form-control'}
                                type="color"
                                value={inputs?.color || ''}
                                placeholder={'kiriting'}
                                onChange={handleChange}
                                onKeyUp={e => e.target.oldValue = e.target.value}
                            />

                            <div className="error">
                                {errors?.color}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="type">Turi</label>
                            <select name="type"
                                    value={inputs?.type || ''}
                                    id="type"
                                    className="form-control"
                                    onChange={handleChange}
                                    onKeyUp={e => e.target.oldValue = e.target.value}
                            >
                                <option value="">Tanlang</option>
                                <option value="daily">Kunlik</option>
                                <option value="monthly">Oylik</option>
                                <option value="annual">Yillik</option>
                                <option value="one-time">Bir martalik</option>
                            </select>
                            <div className="error">
                                {errors?.type}
                            </div>
                        </div>

                        <div className="mb-3">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="is_for_sparepart"
                                    id="is_for_sparepart"
                                    checked={inputs?.is_for_sparepart || false}
                                    onChange={(e) => {
                                        setInputs(prevState => ({
                                            ...prevState, 
                                            is_for_sparepart: e.target.checked
                                        }));
                                    }}
                                />
                                <label className="form-check-label" htmlFor="is_for_sparepart">
                                    Ehtiyot qism harajatlari uchun
                                </label>
                            </div>
                            <div className="error">
                                {errors?.is_for_sparepart}
                            </div>
                        </div>


                        <div className="d-flex gap-2">
                            <Button className="w-50" variant="secondary" type="button" onClick={onClose}>Bekor
                                qilish</Button>
                            <Button className="w-50" variant="primary" type="submit">Saqlash</Button>
                        </div>
                    </form>


                </Modal.Body>

            </Modal>
        </Fragment>
    );
};

ExpenseTemplateCreateForm.propTypes = {
    addExpenseTemplate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    expense_template: state.expense_template,
    expense_templates: state.expense_template.expense_templates,
    error: state.expense_template.error,
    loading: state.expense_template.loading,
});


export default connect(mapStateToProps, {addExpenseTemplate, clearErrors})(ExpenseTemplateCreateForm);
